import axios from 'axios';

import {
  PartialSomethingData,
  Something,
  SomethingResponse,
} from 'src/types/something';
import { PartialUserData, UserResponse } from 'src/types/user';
import {
  Anything,
  AnythingResponse,
  PartialAnythingData,
} from 'src/types/anything';
import { PartialTagData, Tag, TagResponse } from 'src/types/tag';
import { SortBy } from 'src/types/api-general';

// Something
export function createSomething(
  data: PartialSomethingData
): Promise<SomethingResponse> {
  return axios.post('/api/somethings', data);
}
export function updateSomething(
  data: {
    id: Something['id'];
  } & PartialSomethingData & {
      addTags: [];
      removeTags: [];
    }
): Promise<SomethingResponse> {
  const { id, ...values } = data;
  return axios.patch(`/api/somethings/${id}`, values);
}
export function removeSomething(id: Something['id']) {
  return axios.delete(`/api/somethings/${id}`);
}

// Anything
export function createAnything(
  data: PartialAnythingData & {
    SomethingId: number;
  }
): Promise<AnythingResponse> {
  return axios.post('/api/anythings', data);
}
export function updateAnything(
  data: {
    id: Anything['id'];
  } & PartialAnythingData
): Promise<AnythingResponse> {
  const { id, ...values } = data;
  return axios.patch(`/api/anythings/${id}`, values);
}
export function removeAnything(id: Anything['id']) {
  return axios.delete(`/api/anythings/${id}`);
}

// Tag
type GetTagsParams = {
  limit?: number;
  sort_by?: SortBy<keyof Tag>[];
  q?: string;
};
export function getTags(params: GetTagsParams): Promise<TagResponse> {
  return axios.get('/api/tags', {
    params,
  });
}
export function createTag(data: PartialTagData): Promise<TagResponse> {
  return axios.post('/api/tags', data);
}
export function updateTag(
  data: {
    id: Tag['id'];
  } & PartialTagData
): Promise<TagResponse> {
  const { id, ...values } = data;
  return axios.patch(`/api/tags/${id}`, values);
}
export function removeTag(id: Tag['id']) {
  return axios.delete(`/api/tags/${id}`);
}

// User
export function updateUser(data: PartialUserData): Promise<UserResponse> {
  const { id, ...values } = data;
  return axios.patch(`/api/users/${id}`, values);
}

// Search
export function searchAll(term: string) {
  return axios.get(`/api/search?term=${term}`);
}

// File
// Upload file to S3 (via server)
export function uploadImage({ image }: { image: any }) {
  const formData = new FormData();
  formData.append('image', image);
  return axios.post('/api/files', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
// Ask server for presigned AWS S3 URL for a file
export function getSignedUrl({ fileKey }: { fileKey: any }) {
  return axios.get(`/api/files/${fileKey}`);
}
